export const getValidationEstacionModal = () => {
    return {
        estacionesForm: {
            nombre_estacion: [ {required: true, message: 'Nombre estacion es requerido' } ],
            descripcion: [ {required: true, message: 'Descripción es requerido' } ],
            utm: [ {required: true, message: 'UTM es requerido' } ],
        },
        grupoDestiForm: {
            nombre_grupo_destinatario: [ {required: true, message: 'Nombre Grupo es requerido' } ],
        },
        grupoFacturaForm: {
            nombre_grupo_facturacion: [ {required: true, message: 'Nombre Grupo es requerido' } ],
        },
        titularFacturaForm: {
            titular_factura: [ {required: true, message: 'Nombre Titular es requerido' } ]
        },
        crearEmpresaFacturaForm: {
            raz_soc: [ {required: true, message: 'Razón Social es requerido' } ],
            ruc: [ {required: true, message: 'RUC es requerido' } ],
            direccion: [ {required: true, message: 'Dirección es requerido' } ],
        },
        datosEmisionInformeFactura: {
            id_titular_informe: [ {required: true, message: 'Titular Informe es requerido' } ],
            id_grupo_destinatario: [ {required: true, message: 'Grupo Destinatario es requerido' } ],
            id_prioridad: [ {required: true, message: 'Prioridad es requerido' } ],
            id_titular_factura: [ {required: true, message: 'Titular Factura es requerido' } ],
            id_grupo_facturacion: [ {required: true, message: 'Grupo Facturacion es requerido' } ],
            tiempo_entrega: [ {required: true, message: 'Tiempo Entrega es requerido' } ],
            emision_informe: [ {required: true, message: 'Emision Informe es requerido' } ],
        }
    }
}
